export const AppMixin = {
    data() {
        return {
            app: ""
        }
    },
    created() {
        this.app = this.getApp();
    },
    watch: {
        $route() {
            this.app = this.getApp();
        }
    },
    methods: {
        getApp() {
            return this.$route.path.indexOf('/tj') === 0 ? 'tj' :
                this.$route.path.indexOf('/staff') === 0 ? 'staff' : '';
        },
    },
};
